import React, { Component } from 'react'
import _ from 'lodash'
import '../../node_modules/@paypalcorp/pp-vx/dist/core/core.js'
import '../../node_modules/@paypalcorp/pp-vx/dist/components/tabs/tabs.js'
import { InternalFaqs } from '../constants/FAQ/corp'
import { ExternalFaqs } from '../constants/FAQ/adhoc'
import { isCorpOrGoPayUser } from '../helper'
import { constants } from '../constants/constants'
import { Message } from '@paypalcorp/worldready-react'

class HelpPage extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      helpMenu: [
        {
          name: 'FAQ',
          key: 'faq',
          selected: true,
          display: true,
        },
        {
          name: 'Tutorials',
          key: 'tutorials',
          selected: false,
          display: false,
        },
        {
          name: 'Contact',
          key: 'contact',
          selected: false,
          display: true,
        },
      ],
      displayHelpMenuFor: 'faq',
    }
  }

  setHelpMenuVisisbility = (displayHelpMenuFor) => {
    this.setState({ displayHelpMenuFor })
  }

  handleClickScroll = (index, type) => {
    const id = `${type}_question_${index}`
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  renderHelpMenus = () => {
    const { helpMenu, displayHelpMenuFor } = this.state
    const { user } = this.props

    return (
      <nav className="ppvx_tabs__nav" role="tablist">
        <div
          id="tabgroup2-tabs"
          className="ppvx_tabs__tabs-wrapper ppvx_tabs--centered"
          role="tablist"
        >
          {helpMenu.map((menu) => {
            return menu.display ? (
              <button
                id={`tabgroup2-tab_${menu.key}`}
                className="ppvx_tabs__tab"
                aria-controls={`tabgroup2-content_${menu.key}`}
                role="tab"
                aria-selected={menu.key === displayHelpMenuFor}
                key={menu.key}
                data-pa-pgrp={`dropzone:${user.accType}`}
                data-pa-page={`dropzone:help:${menu.key}:${user.accType}`}
                data-pa-click={menu.key}
                onClick={() => this.setHelpMenuVisisbility(menu.key)}
              >
                <Message id={`header.submenu.${menu.key}`} />
              </button>
            ) : (
              ''
            )
          })}
        </div>
      </nav>
    )
  }

  renderAnswer = (faq, answer, answer_index) => {
    return _.isArray(answer) ? (
      <ul className="help_list-style" key={`${faq.question}_${answer_index}`}>
        {answer.map((ans, ans_index) => {
          return (
            <li
              className={`faq__answer ppvx_text--md faq__answer_list-li ${
                _.get(faq, 'style', '') === 'decimal' &&
                'faq__answer-style--decimal'
              }`}
              key={`${faq.question}_${ans_index}`}
            >
              <Message
                id={ans}
                link={(innerMessage) => (
                  <a
                    href={`mailto:${innerMessage.props.messageParts[0].value}`}
                  >
                    {' '}
                    {innerMessage}
                  </a>
                )}
                bold={(innerMessage) => <b>{innerMessage}</b>}
              />
            </li>
          )
        })}
      </ul>
    ) : (
      <div
        className="faq__answer ppvx_text--md"
        key={`${faq.question}_${answer_index}`}
      >
        <Message
          id={answer}
          link={(innerMessage) => (
            <a href={`mailto:${innerMessage.props.messageParts[0].value}`}>
              {' '}
              {innerMessage}
            </a>
          )}
          bold={(innerMessage) => <b>{innerMessage}</b>}
        />
      </div>
    )
  }

  renderTabels = (displayHelpMenuFor, FAQ) => {
    return (
      <div className="faq__table-of-content">
        <div className="faq__questions_list">
          {FAQ.map((faq, index) => {
            return (
              <div
                className="faq__questions_tables ppvx_text--md"
                key={`faq__questions_tables_${index}`}
                onClick={() =>
                  this.handleClickScroll(index, displayHelpMenuFor)
                }
              >
                {`${index + 1}. `} <Message id={faq.question} />
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  renderFAQs = () => {
    const { user } = this.props
    const { displayHelpMenuFor } = this.state
    const FAQ = isCorpOrGoPayUser(user) ? InternalFaqs : ExternalFaqs

    return (
      <div
        className="ppvx_tabs__tab-content"
        id={`tabgroup2-content_${displayHelpMenuFor}`}
        aria-hidden={displayHelpMenuFor === 'contact'}
        aria-labelledby={`tabgroup2-tab_${displayHelpMenuFor}`}
        tabIndex="0"
        role="tabpanel"
      >
        {this.renderTabels(displayHelpMenuFor, FAQ)}
        {FAQ.map((faq, index) => {
          return (
            <div className="faq__content ppvx_text--md" key={`faq_${index}`}>
              <div
                className="faq__question"
                id={`${displayHelpMenuFor}_question_${index + 1}`}
              >
                {`${index + 1}. `} <Message id={faq.question} />
              </div>
              {faq.answer.map((answer, answer_index) => {
                return this.renderAnswer(faq, answer, answer_index)
              })}
              {_.has(faq, 'notes') && (
                <div className="faq__notes">
                  Note: <Message id={faq.notes} />
                </div>
              )}
            </div>
          )
        })}
      </div>
    )
  }

  renderContact = () => {
    const { user } = this.props
    const { displayHelpMenuFor } = this.state

    const userType =
      user.accType === constants.CorpUser
        ? constants.corpKey
        : constants.adhocKey
    return (
      <div
        className="ppvx_tabs__tab-content"
        id="tabgroup2-content_contact"
        aria-hidden={displayHelpMenuFor !== 'contact'}
        aria-labelledby="tabgroup2-tab_contact"
        tabIndex="0"
        role="tabpanel"
      >
        <div className="help_contact-content ppvx_text--md">
          <div>
            <Message id="contact.label" />
          </div>
          <ul className="help_list-style">
            {userType === constants.corpKey && (
              <li className="faq__answer_list-li">
                <Message id="contact.slack" />
              </li>
            )}
            <li className="faq__answer_list-li">
              <Message
                id={`contact.email.${userType}`}
                link={(innerMessage) => (
                  <a
                    href={`mailto:${innerMessage.props.messageParts[0].children[0].value}`}
                  >
                    {' '}
                    {innerMessage}
                  </a>
                )}
                bold={(innerMessage) => <b>{innerMessage}</b>}
              />
            </li>
          </ul>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="help__container">
        <div id="tabgroup2" className="ppvx_tabs">
          {this.renderHelpMenus()}
          {this.renderFAQs()}
          {this.renderContact()}
        </div>
      </div>
    )
  }
}

export default HelpPage
